import { PersonRegisterContainer } from "../../containers/RegisterSystem/PersonRegisterContainer";

export function PersonalRegisterPage() {
    return (
        <PersonRegisterContainer />
    )
}